import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

export const HardwareAssetsService = {
  fetchHardwareAssets: async () => {
    try {
      const response = await axiosInstance.get(API.hardwareAssets.getAll);
      return response.data;
    } catch (error) {
      console.error("Error fetching Hardware assets:", error);
      throw error;
    }
  },
};
